import React from 'react'
import { EntityInfoNameLineProps } from './EntityInfoNameLine.types'
import styles from './EntityInfoNameLine.module.scss'
import cl from 'classnames'
import { ImagePortrait } from '../ImagePortrait'
import { Input } from '../Input'
import { Button } from '../Button'
import { H1 } from '../H1'
import { RatingStars } from '../RatingStars'
import { useGetIsResponsiveScreen } from 'utilities'

const EntityInfoNameLineComponent = (props: EntityInfoNameLineProps) => {
  const {
    className,
    style,
    imageProps,
    editMode,
    nameInputProps,
    onDiscardChangesClick,
    onSaveChangesClick,
    entityName,
    ratingProps
  } = props

  const { isResponsive: isMobile } = useGetIsResponsiveScreen('(max-width: 920px)')
  return (
    <div
      className={cl(styles.nameContainer, className)}
      style={style}
    >
      <ImagePortrait
        width={40}
        {...imageProps}
      />

      <div>
        {editMode
          ? (
            <div className={isMobile && cl(styles.flexCol, styles.alignStart, styles.gap10)}>
              <Input
                className={styles.nameInput}
                {...nameInputProps}
              />
              {!!ratingProps && isMobile && (
                <RatingStars {...ratingProps} />
              )}
              <div className={styles.flexRowWrap}>
                {onDiscardChangesClick && (
                  <Button
                    preset='secondary'
                    onClick={onDiscardChangesClick}
                  >
                    Discard changes
                  </Button>
                )}
                {onSaveChangesClick && (
                  <Button
                    preset='primary'
                    onClick={onSaveChangesClick}
                  >
                    Save changes
                  </Button>
                )}
              </div>
            </div>
          )
          : (
            <H1 bold>{entityName}</H1>
          )}

        {!!ratingProps && !isMobile && (
          <RatingStars {...ratingProps} />
        )}
      </div>

    </div>
  )
}

const EntityInfoNameLine = EntityInfoNameLineComponent
export { EntityInfoNameLine }
